export class InvitationToken {
	public Id: string;
	public expired: boolean;
	public expiredContent: string | null;
	public used: boolean;
	public usedContent: string | null;
	public relatedEmail?: string;
}
